<template>
  <DxTagBox
    :data-source="dataSource"
    v-model:value="currentValue"
    :show-selection-controls="true"
    :input-attr="{ 'aria-label': 'Name' }"
    :show-multi-tag-only="false"
    @value-changed="onValueChanged"
    @selection-changed="onSelectionChanged"
    :search-enabled="true"
    value-expr="id"
    display-expr="nama"
    apply-value-mode="useButtons"
  />
</template>

<script>
import { ref } from "vue";
import DxTagBox from "devextreme-vue/tag-box";

export default {
  components: {
    DxTagBox,
  },
  props: {
    cellInfo: Object,
    dataSource: Object,
    dataGridComponent: Object,
  },
  setup(props) {
    const currentValue = ref(props.cellInfo.value);

    const onSelectionChanged = () => {
      props.dataGridComponent.updateDimensions();
    };

    const onValueChanged = (e) => {
      props.cellInfo.setValue(e.value);
    };

    return {
      currentValue,
      onSelectionChanged,
      onValueChanged,
    };
  },
};
</script>
